/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>


  <div class="mc-form-register">

    <div class="mc-form-register-input">

      <ion-item>
        <ion-label position="stacked">{{$t('Register.gender')}} <span v-if="genderRequired">*</span></ion-label>
        <ion-select
          required
          :value="user.gender"
          @ionChange="user.gender = Number($event.target.value)"
          :cancel-text="$t('Commons.cancel')"
          :placeholder="$t('Register.gender')"
        >
          <ion-select-option :value="3">{{$t('Register.nc')}}</ion-select-option>
          <ion-select-option :value="2">{{$t('Register.male')}}</ion-select-option>
          <ion-select-option :value="1">{{$t('Register.female')}}</ion-select-option>
        </ion-select>
      </ion-item>
      <div v-if="v$.user.gender && v$.user.gender.$error">
        <div class="mc-error-label"  v-if="v$.user.gender.required.$invalid">{{$t('Validation.required')}}</div>
      </div>

      <ion-item>
        <ion-label>{{ $t('Register.birthDate') }} <span v-if="requiredBirthdate">*</span></ion-label>
        <ion-datetime-button slot="end" datetime="datePickerHitchHikingRegister"></ion-datetime-button>
        <ion-modal :keep-contents-mounted="true">
          <ion-datetime
            display-format="DD/MM/YYYY"
            picker-format="DD/MM/YYYY"
            presentation="date"
            :show-default-buttons="true"
            :cancel-text="$t('Commons.cancel')"
            :done-text="$t('Commons.validate')"
            :value="user.birthDate.toString()"
            :max="now"
            :first-day-of-week="1"
            @ionChange="user.birthDate = $event.detail.value; checkBirthdate()"
            id="datePickerHitchHikingRegister"
          ></ion-datetime>
        </ion-modal>
      </ion-item>
      <div v-if="v$.user.birthDate && v$.user.birthDate.$error">
        <div class="mc-error-label"  v-if="v$.user.birthDate.required.$invalid">{{$t('Validation.required')}}</div>
        <div class="mc-error-label"  v-if="v$.user.birthDate.isMaxBirthDate.$invalid">{{$t('Validation.age', { value: minAge })}}</div>
      </div>

      <div v-if="needParentalConsent">
        <ion-item>
          <ion-label position="stacked">{{$t('Register.legal')}} *</ion-label>
          <ion-input
            type="email"
            :placeholder="$t('Register.legal') + '*'"
            :value="user.legalGuardianEmail"
            @input="user.legalGuardianEmail = $event.target.value"
          ></ion-input>
        </ion-item>
        <div class="ion-text-start legal-desc">
          {{$t('Register.legalDesc')}}
      </div>
        <div v-if="v$.user.legalGuardianEmail.$error">
          <div class="mc-error-label" v-if="v$.user.legalGuardianEmail.required.$invalid">{{$t('Validation.required')}}</div>
          <div class="mc-error-label" v-if="v$.user.legalGuardianEmail.email.$invalid">{{$t('Validation.email')}}</div>
        </div>
      </div>

      <div class="mc-select-communities text-left" v-if="showCommunities && this.communities.length > 0">
        <ion-item class="item-communities">
          <ion-label position="stacked">{{$t('Register.community')}}</ion-label>
          <ion-select
            placeholder="Sélectionnez une communauté"
            interface="alert"
            cancel-text="Fermer"
            ok-text="Valider"
            :value="user.communityId"
            @ionChange="setCommunities($event)"
          >
            <ion-select-option
              v-for="community in communities"
              :key="community.id"
              :value="community.id"
            >{{ community.name }}</ion-select-option>
          </ion-select>
        </ion-item>
        <div v-if="v$.user.communityId && v$.user.communityId.$error">
          <div class="mc-error-label"  v-if="v$.user.communityId.required.$invalid">{{$t('Validation.required')}}</div>
        </div>
      </div>
      <br>

      <ion-grid class="ion-no-margin">
              <ion-row>
                <ion-col size="4">
                  <ion-item>
                    <ion-label position="stacked">{{$t('Register.indicatif')}} *</ion-label>
                    <ion-select :value="user.phoneCode" @ionChange="user.phoneCode = Number($event.target.value);" :cancel-text="'Annuler'" style="font-size: 14px;">
                      <ion-select-option v-for="indicatif in indicatifs" v-bind:value="indicatif.value" >
                        <div><span :class="'fi fi-' + indicatif.country"></span> {{indicatif.code}}</div>
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
                <ion-col size="8">
                  <ion-item>
                    <ion-label position="stacked">{{$t('HitchHiking.register.phone')}} *</ion-label>
                    <ion-input
                      type="text"
                      name="telephone"
                      :value="user.telephone"
                      @input="user.telephone = $event.target.value;"
                      @ionBlur="checkedPhoneNumber = null"
                      :placeholder="$t('HitchHiking.register.phone')"
                    ></ion-input>
                    <ion-icon
                      style="margin-top: 16px"
                      slot="end"
                      size="large"
                      color="primary"
                      class="rotating"
                      v-if="this.$store.state.registerStore.statusCheckPhoneNumberValidity == 'loading'"
                      name="md-sync"
                    ></ion-icon>
                  </ion-item>
                  <div v-if="v$.user.telephone && v$.user.telephone.$error">
                    <div class="mc-error-label"  v-if="v$.user.telephone.required.$invalid">{{$t('Validation.required')}}</div>
                    <div class="mc-error-label" v-if="v$.user.telephone.checkPhoneNumberValidity.$invalid">{{ this.$store.state.registerStore.checkPhoneNumberValidityMessage }}</div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>

      <ion-item v-on:click="goGeoSearch('register_address_hitchhiking', 'search')">
        <ion-label position="stacked">{{$t('HitchHiking.register.address')}} *</ion-label>
        <ion-input
          type="text"
          name="address"
          :value="displayAddress"
          readonly="true"
          class="no-clickable ellipsis"
          v-bind:placeholder="$t('HitchHiking.register.address')"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.addresses && v$.user.addresses.$error">
        <div class="mc-error-label"  v-if="v$.user.addresses.required.$invalid">{{$t('Validation.required')}}</div>
        <div class="mc-error-label"  v-if="v$.user.addresses.fullAddress.$invalid">{{$t('HitchHiking.validation.fullAddress')}}</div>
      </div>

      <ion-item>
        <ion-label position="stacked">{{$t('HitchHiking.register.postalAddress')}} </ion-label>
        <ion-input
          type="text"
          name="address"
          :value="user.postalAddress"
          @input="changePostalAddress($event)"
          v-bind:placeholder="$t('HitchHiking.register.postalAddress')"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.postalAddress && v$.user.postalAddress.$error">
        <div class="mc-error-label"  v-if="v$.user.postalAddress.required.$invalid">{{$t('Validation.required')}}</div>
      </div>
      <br>

      <div class="text-left" v-if="user.addresses && user.addresses[0]">
        <div><small><ion-label position="stacked">{{$t('HitchHiking.register.total-address')}}</ion-label></small></div>
        <div>{{user.givenName}} {{user.familyName}}</div>
        <div>{{user.postalAddress}}</div>
        <div>
          <div>{{user.addresses[0].houseNumber}} {{user.addresses[0].streetAddress}}</div>
          <div>{{user.addresses[0].postalCode}} {{user.addresses[0].addressLocality}}</div>
        </div>
      </div>



      <br><br>
      <div class="text-asterisk text-left"><small>* Champ obligatoire</small></div>

    </div>
    <br>
    <!--
    <ion-button v-if="instance == 'mobicoop'"  class='mc-small-button' color="primary" expand="block" fill="outline" @click="goToCovoit()">
      PLUTÔT COVOIT' ?
    </ion-button>
    -->

  </div>

</template>

<style lang="scss">

.no-white-space {
  white-space: normal !important;
}
.mc-form-register {
  display: block;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  .mc-form-register-input {
    flex: 1;
    flex-direction: column;
    display: flex;
    justify-content: center
  }
}

.text-asterisk {
  font-size: 14px;
  color: rgba(0,0,0,0.4)
}

</style>

<script>
import {required, email, sameAs, minLength, requiredIf} from '@vuelidate/validators'
import { nextTick } from 'vue';
import { mapState } from 'vuex'
import useVuelidate from "@vuelidate/core";
var moment = require('moment');


const isMaxBirthDate = (value, vm) => {
  if (JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE)) {
    let n = new Date();
    n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
    return moment(value).isBefore(moment(n.toISOString()));
  } else {
    return true;
  }
}

export default {
  name: 'hitchHiking.registerStep2',
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      instance: process.env.VUE_APP_INSTANCE,
      maxBirthDate: this.getMaxBirthDate(),
      minAge: process.env.VUE_APP_REGISTER_MIN_AGE,
      minorAge: 18,
      requiredBirthdate: JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE),
      parentalConsentActivated: JSON.parse(process.env.VUE_APP_PARENTAL_CONSENT),
      showCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY),
      neededCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY_NEEDED),
      genderRequired: JSON.parse(process.env.VUE_APP_GENDER_REQUIRED),
      fullAddressRequired: JSON.parse(process.env.VUE_APP_HITCHHIKING_REGISTER_FULL_ADDRESS),
      communities: [],
      checkedPhoneNumber: null,
      now: new Date().toISOString(),
      indicatifs: JSON.parse(process.env.VUE_APP_PHONE_IND),
      needParentalConsent: false
    }
  },
  validations() { return {
    user: {
      telephone: {
        required,
        checkPhoneNumberValidity(telephone) {
          if (!this.checkedPhoneNumber) {
            this.checkedPhoneNumber = this.$store.dispatch('checkPhoneNumberValidity', telephone).then(res => {
              setTimeout(() => {
                // this.$parent.next()
              }, 0)
              return res
            }).catch(err => {
              console.log(err);
            });
            return this.checkedPhoneNumber
          } else {
            return this.checkedPhoneNumber
          }
        }
      },
      addresses: {
        required,
        fullAddress(address) {
          return this.fullAddressRequired ? (address[0] ? (address[0].type === "housenumber" || address[0].type === "street" ) : false) : true;
        }
      },
      gender: {
        required: requiredIf(function () {
          return this.genderRequired;
        }),
      },
      birthDate: {
        required: requiredIf(function () {
          return this.requiredBirthdate;
        }),
        isMaxBirthDate
      },
      legalGuardianEmail: {
        required :  requiredIf(function () {
          return this.needParentalConsent && this.parentalConsentActivated;
        }),
        email
      },
      communityId: {
        required: requiredIf(function () {
          return this.neededCommunities;
        }),
      },

    }
  }
  },
  computed: {
    user : {
      get() {
        return this.$store.state.registerStore.userToRegister
      },
      set(user) {
        this.$store.commit('register_update', user);
      }
    },
    displayAddress : {
      get() {
        return this.$store.state.registerStore.displayAddress
      }
    },
  },
  created() {
    if (!this.user.hitchHikeDriver && !this.user.hitchHikePassenger) {
      this.user.hitchHikeDriver = true;
    }
    if (this.showCommunities) {
      this.$store.dispatch('getAllCommunities', {query: '', number: 1000}).then(res => {
        this.communities = res.data['hydra:member']
      })
    }
  },
  methods: {
    getMaxBirthDate() {
      let n = new Date();
      n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
      return n.toISOString();
    },
    goGeoSearch(type, action) {
      this.$router.push({ name: "geoSearch", query: { type, action, fullAddressRequired: this.fullAddressRequired }});
    },
    async validate() {
      console.log(this.v$)
      await this.v$.$reset();
      await this.v$.$touch();
      if (this.v$.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    changePostalAddress(event) {
      this.user.postalAddress = event.target.value;
    },
    setCommunities(event) {
      this.user.communityId = event.detail.value;
    },
    goToCovoit() {
      this.$router.push({name:'register', query: {step: 1}});
    },
    checkBirthdate() {
      let minAge = new Date();
      minAge.setFullYear(minAge.getFullYear() - this.minAge);
      let legalAge = new Date();
      legalAge.setFullYear(legalAge.getFullYear() - this.minorAge);
      const res = moment(this.user.birthDate).isBefore(moment(minAge.toISOString())) && moment(this.user.birthDate).isAfter(moment(legalAge.toISOString()));
      if (this.parentalConsentActivated && res) {
        this.needParentalConsent = true
      } else {
        this.needParentalConsent = false
      }
    }

  }
}
</script>
